export interface StoreApplication {
  url: string;
}

export function StoreApplicationActions() {
  function storeApplicationInfo(url: string): StoreApplication {
    return {
      url: url,
    };
  }

  function deserialize(object: string): StoreApplication {
    const parseResponse = JSON.parse(JSON.stringify(object));

    return storeApplicationInfo(parseResponse.url);
  }

  return {
    storeApplicationInfo,
    deserialize,
  };
}